import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from "moment";
import Err from "@Broker/@Routes/error";
import Amplitude from "@Shared/utils/amplitude";
import { kebabCase } from "lodash";
import { isCurrentMonth } from "@Shared/utils/helpers/dates";
import { mapActions } from "vuex";
import { PIN_REFERRER_TIMELINE_ITEM } from "@Broker/@Modules/clients/referrers/store/referrer-actions.ts";
import ReferrerTimelineNote from "./referrer-timeline-note.vue";
import ReferrerTimelineChecklist from "./referrer-timeline-checklist.vue";
import ReferrerTimelineFollowUp from "./referrer-timeline-follow-up.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ReferrerTimelineList",
  components: {
    ReferrerTimelineNote,
    ReferrerTimelineChecklist,
    ReferrerTimelineFollowUp
  },
  props: {
    timelineList: {
      type: Array,
      default: () => []
    },
    isEmptyTimeline: {
      type: Boolean,
      required: true
    },
    referrerId: {
      type: [String, Number],
      required: true
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions("ReferrerStore", [PIN_REFERRER_TIMELINE_ITEM])), {}, {
    toHyphens(name) {
      return kebabCase(name);
    },
    isCurrentMonth(month) {
      return isCurrentMonth(month);
    },
    getTimelineComponent(activityType) {
      return `referrer-timeline-${activityType}`;
    },
    getTooltipTitle(activity, updatedAt, createdAt, scheduledDate, scheduledTime, complete) {
      const title = {
        "follow-up": complete ? this.formatTooltipDates(updatedAt) : this.$t("client-profile.messages.scheduledAt", {
          date: this.$options.filters.formatUTC(scheduledDate),
          time: moment(scheduledTime, "'HH:mm'").format("LT")
        }),
        note: this.formatTooltipDates(updatedAt)
      };
      return title[activity] || this.formatTooltipDates(createdAt);
    },
    formatTooltipDates(date) {
      return this.$options.filters.momentLocal(date, "MMM. DD, YYYY");
    },
    getItemVariation(activity) {
      const variationFor = {
        "follow-up": "-30",
        note: "30",
        "account-creation": "45",
        event: "75",
        checklist: "-60"
      };
      return (variationFor[activity] || "0") + "deg";
    },
    parseClassItem(activity) {
      const classes = {
        "follow-up": "fa fa-bell-o",
        "account-creation": "dot-icon",
        note: "fa fa-file-text-o",
        checklist: "fa fa-list",
        event: "fa fa-calendar-o"
      };
      return classes[activity];
    },
    async pinItem(id, type, pinned) {
      try {
        await this.PIN_REFERRER_TIMELINE_ITEM({
          referrerId: this.referrerId,
          id,
          pinned: !pinned,
          type
        });
      } catch (e) {
        Err.handle(e);
        Amplitude.logHandledError(e);
      }
    },
    handleIconClick(type) {
      this.$emit("filter", type);
    }
  })
});